const getSelectionDataById = (selectionsData) => (selectionId) => {
	return selectionsData.find(x => x.get('id') === selectionId);
}

export {getSelectionDataById}